var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteConfiguration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.9724C17 12.9883 16.3832 12.1474 15.5125 11.8085C16.3118 10.8956 16.2744 9.51165 15.399 8.64316C14.5155 7.76663 13.1021 7.73676 12.1823 8.55317C11.8619 7.64869 10.9939 7 9.97221 7C8.95054 7 8.10565 7.63146 7.77487 8.51718C6.85432 7.73868 5.471 7.78042 4.60101 8.64354C3.72601 9.51165 3.68858 10.8956 4.48754 11.8089C3.61678 12.1478 3 12.9883 3 13.9724C3 14.9704 3.63377 15.8208 4.52382 16.1502C3.68703 17.0623 3.71289 18.4749 4.60101 19.3565C5.471 20.2196 6.85471 20.2613 7.77487 19.4828C8.10565 20.3685 8.96444 21 9.97221 21C10.98 21 11.8619 20.3513 12.1823 19.4464C13.1021 20.2629 14.5155 20.233 15.399 19.3565C16.2871 18.4753 16.313 17.0623 15.4762 16.1502C16.3662 15.8208 17 14.97 17 13.9724Z",
    stroke: "#929292",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 2,
    stroke: "#929292",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2,
    stroke: "#929292",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteConfiguration);
export default __webpack_public_path__ + "static/media/site-configuration.3c24c72a4feae112db2d8d4484dcc29c.svg";
export { ForwardRef as ReactComponent };